import { Injectable } from '@angular/core';
import { Adapter } from '../adapter.service';
import { RiwayatKepangkatan } from 'src/app/shared/models/pegawai/riwayat-kepangkatan.model';

@Injectable({
  providedIn: 'root',
})
export class RiwayatKepangkatanAdapter implements Adapter<RiwayatKepangkatan> {
  adapt(item: any): RiwayatKepangkatan {
    return {
      id: item.idRiwayatKepangkatan,
      idKaryawan: item.idKaryawan,
      idJabatan: item.idJabatan,
      idGolonganJabatan: item.idGolonganJabatan,
      tmt: item.tmt,
      noSk: item.noSk,
      tanggalSk: item.tanggalSk,
      pejabatPenandatangan: item.pejabatPenandatangan,
      dateMake: item.dateMake,
      url: item.url,
      idDataKlinik: item.idDataKlinik,
      pangkat: item.pangkat,
      golongan: item.golongan,
      namaKaryawan: item.namaKaryawan,
      statusAktif: item.statusAktif,
      catatan: item.catatan,
    };
  }
}
